define('views/pages/news/index',['require','jquery','views/base/page','views/pages/news/news','views/pages/news/tags','text!templates/pages/news/index.ejs','helpers/application','lib/utils'],function(require) {
    'use strict';

    var $ = require('jquery'),
        PageView = require('views/base/page'),
        // NavbarView = require('views/pages/news/navbar'),
        NewsListView = require('views/pages/news/news'),
        NewsTagsView = require('views/pages/news/tags'),
        template = require('text!templates/pages/news/index.ejs'),
        applicationHelper = require('helpers/application'),
        utils = require('lib/utils');


    var PagesNewsPageView = PageView.extend({
        id: 'pages-news-page',
        autoRender: true,
        template: template,
        windowResize: true,
        regions: {
            'news-list': '#news-page-container',
            'news-tags': '#news-tags-cloud'
        },
        listen: {
            'resize model': 'onResize',
            'change:loading model': 'render'
        },
        onResize: function(){
            console.log('ON RESIZE');
            var newsListHeight = $('body').height() - $('#news-page-container', this.$el).offset().top - 18;
            $('.news-list', this.$el).css('min-height', newsListHeight);
        },
        initialize: function() {
            PageView.prototype.initialize.apply(this, arguments);

            this.subscribeEvent('viewNews', this.viewNews);

            this.subview('news', new NewsListView({model: this.model, collection: this.model.items }));
            this.subview('tags', new NewsTagsView({model: this.model, collection: this.model.tags }));
        },
        fromDateChange: function(model, date) {
            if (date.valueOf() > model.get('toDate').valueOf()) {
                var newDate = new Date(date);
                newDate.setDate(newDate.getDate() + 1);
                model.set('toDate', newDate);
            }

            if (this.fromDate) {
                this.fromDate.setValue(date);
            }
            this.updateURL();
        },

        viewNews: function(newsModel){
            console.log('viewNews>>>>>');
            applicationHelper.redirectTo('news#item', { newsId: newsModel.get('ID') }, { forceStartup: true });
        },

        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('news').render();
            this.subview('tags').render();

            this.onResize();
        },

        updateURL: function() {
            utils.changeURL('news#list', { tags: encodeURIComponent(this.model.get('fromDate')) });
        },

        dispose: function() {
            if (this.disposed) { return; }
            PageView.prototype.dispose.apply(this, arguments);
        }
    });

    return PagesNewsPageView;
});

